export default "__VITE_ASSET__DPK55G4Q__"